import { cx, useTranslations } from "@jugl-web/utils";
import React from "react";

export const InisghtsCard: React.FC<{
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: React.ReactNode;
  conversations: number;
  messages?: number;
  backgroundColor: string;
  orientation?: "row" | "column";
}> = ({
  icon,
  title,
  conversations,
  messages,
  backgroundColor,
  orientation,
}) => {
  const { t } = useTranslations();

  return (
    <div
      className={cx(
        "flex max-w-[300px] min-w-[300px] grow gap-4 rounded-[48px] p-8",
        orientation === "column" && "flex-col justify-center",
        backgroundColor
      )}
    >
      {React.createElement(icon, {
        className: cx(
          "w-[57px] h-[57px] shrink-0",
          orientation === "column" && "mx-auto"
        ),
      })}
      <div className="flex flex-col gap-2">
        <span className="font-secondary text-sm font-light text-dark italic">
          #{title}
        </span>
        <div className="flex flex-col gap-1.5">
          <span className="font-secondary text-sm text-dark-800">
            {t(
              {
                id: "client-support-page.conversations-count",
                defaultMessage:
                  "{count} {count, plural, one {conversation} other {conversations}}",
              },
              {
                count: (
                  <span className="font-secondary text-base leading-[140%] font-semibold text-black">
                    {conversations}
                  </span>
                ),
              }
            )}
          </span>
          {typeof messages === "number" && (
            <span className="font-secondary text-sm text-dark-800">
              {t(
                {
                  id: "client-support-page.messages-count",
                  defaultMessage:
                    "{count} {count, plural, one {message} other {messages}}",
                },
                {
                  count: (
                    <span className="font-secondary text-base leading-[140%] font-semibold text-black">
                      {messages}
                    </span>
                  ),
                }
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
